import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Bouche = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.46 56.46">
  <G fill={color}>
    <Path d="M84.46,21.48C78.86,14.92,65.07,0,55.49,0c-6.18,0-10.64,1.5-13.34,2.8-2.7-1.3-7.16-2.8-13.34-2.8C19.34,0,5.75,14.58.03,21.26c28.03,3.9,56.39,3.97,84.43.22Z"/>
    <Path d="M0,31.18c5.14,6.67,21.35,25.28,42.15,25.28s36.59-18.13,41.94-25.01c-13.63,1.75-27.33,2.63-41.04,2.63-14.38,0-28.76-.97-43.05-2.9Z"/>
  </G>
</Svg>
);
};

export default Bouche;
